import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Image"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 3H4.5C3.67157 3 3 3.67157 3 4.5V19.5C3 20.3284 3.67157 21 4.5 21H19.5C20.3284 21 21 20.3284 21 19.5V4.5C21 3.67157 20.3284 3 19.5 3ZM4.5 19.5V15L8.25 11.25L12.4425 15.4425C13.0276 16.0241 13.9724 16.0241 14.5575 15.4425L15.75 14.25L19.5 18V19.5H4.5ZM16.8075 13.185L19.5 15.8775V4.5H4.5V12.8775L7.1925 10.185C7.77756 9.60342 8.72244 9.60342 9.3075 10.185L13.5 14.3775L14.6925 13.185C15.2776 12.6034 16.2224 12.6034 16.8075 13.185ZM14.25 10.5C15.4926 10.5 16.5 9.49264 16.5 8.25C16.5 7.00736 15.4926 6 14.25 6C13.0074 6 12 7.00736 12 8.25C12 9.49264 13.0074 10.5 14.25 10.5ZM15 8.25C15 7.83579 14.6642 7.5 14.25 7.5C13.8358 7.5 13.5 7.83579 13.5 8.25C13.5 8.66421 13.8358 9 14.25 9C14.6642 9 15 8.66421 15 8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Image.vue"]]);
